import "./CockpitDashboard.scss";
import ConsumptionChart from "./ConsumptionChart";
import {
  AssetsIcon,
  ESGIcon,
  TrendingUpIcon,
  AlertIcon,
  BusinessIcon,
} from "../../../../../shared/cockpit/components/icons/Icon";

interface StatCardProps {
  title: string;
  value: string;
  unit?: string;
  subtitle?: string;
  variant?: "primary" | "warning" | "success" | "danger";
  badge?: {
    text: string;
    type: "positive" | "negative" | "neutral";
  };
  link?: string;
  Icon: React.ElementType;
}

function StatCard({
  title,
  value,
  unit,
  subtitle,
  variant = "primary",
  badge,
  link,
  Icon,
}: StatCardProps) {
  return (
    <div className={`stat-card stat-card--${variant}`}>
      <div className="stat-card__content">
        <h3 className="stat-card__title">{title}</h3>
        <div className="stat-card__value-container">
          <span className="stat-card__value">{value}</span>
          {unit && <span className="stat-card__unit">{unit}</span>}
        </div>
        {badge && (
          <div className={`stat-card__badge stat-card__badge--${badge.type}`}>
            {badge.text}
          </div>
        )}
        {subtitle && <p className="stat-card__subtitle">{subtitle}</p>}
        {link && (
          <a href="#" className="stat-card__link">
            {link}
          </a>
        )}
      </div>
      <Icon className="stat-card__icon" />
    </div>
  );
}

interface BusinessUnitProps {
  name: string;
  locations: string;
  value: string;
  percentage: string;
  isPositive: boolean;
  color: string;
}

function BusinessUnitItem({
  name,
  locations,
  value,
  percentage,
  isPositive,
  color,
}: BusinessUnitProps) {
  return (
    <div className="business-unit-item" style={{ borderLeftColor: color }}>
      <div className="business-unit-item__main">
        <h4 className="business-unit-item__name">{name}</h4>
        <p className="business-unit-item__locations">{locations} Standorte</p>
      </div>
      <div className="business-unit-item__stats">
        <span className="business-unit-item__value">{value} GWh</span>
        <span
          className={`business-unit-item__percentage business-unit-item__percentage--${isPositive ? "positive" : "negative"}`}
        >
          {isPositive ? "+" : ""}{percentage}%
        </span>
      </div>
    </div>
  );
}

function CockpitDashboard() {
  return (
    <div className="cockpit-dashboard">
      <div className="cockpit-dashboard__header">
        <h2 className="cockpit-dashboard__title">Schmidt Gruppe Cockpit</h2>
        <p className="cockpit-dashboard__subtitle">
          Aggregierte Energie- und Infrastrukturdaten der Schmidt Gruppe
        </p>
      </div>
      <div className="cockpit-dashboard__grid">
        <StatCard
          title="GESAMTVERBRAUCH YTD"
          value="32.5"
          unit="GWh"
          variant="primary"
          badge={{ text: "↘ 4.2% vs. Vorjahr", type: "positive" }}
          Icon={AssetsIcon}
        />
        <StatCard
          title="TRADING ERSPARNIS"
          value="842.5"
          unit="T€"
          variant="warning"
          subtitle="Durch Spotmarkt-Optimierung"
          Icon={TrendingUpIcon}
        />
        <StatCard
          title="CO2 REDUKTION"
          value="1,240"
          unit="t"
          variant="success"
          badge={{ text: "↗ 12% über Ziel", type: "positive" }}
          Icon={ESGIcon}
        />
        <StatCard
          title="KRITISCHE ALERTS"
          value="3"
          unit="Standorte"
          variant="danger"
          link="Details ansehen →"
          Icon={AlertIcon}
        />
      </div>
      <div className="cockpit-dashboard__chart-sidebar-layout">
        <div className="cockpit-dashboard__chart-container">
          <ConsumptionChart />
        </div>

        <div className="cockpit-dashboard__sidebar">
          <div className="business-units-card">
            <div className="business-units-card__header">
                <BusinessIcon className="business-units-card__icon"/>
              <h3 className="business-units-card__title">Business Units</h3>
            </div>

            <div className="business-units-card__list">
              <BusinessUnitItem
                name="FitX Studios"
                locations="110"
                value="78.8"
                percentage="4"
                isPositive={true}
                color="#f59e0b"
              />
              <BusinessUnitItem
                name="Spielstationen"
                locations="150"
                value="43.8"
                percentage="2"
                isPositive={false}
                color="#1e1b4b"
              />
              <BusinessUnitItem
                name="Immobilien / CaOs"
                locations="85"
                value="13.1"
                percentage="1"
                isPositive={true}
                color="#10b981"
              />
            </div>

            <button className="business-units-card__add-btn">
              + Unit hinzufügen
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CockpitDashboard;
